import { ColorPicker, useColor } from "react-color-palette";
import "react-color-palette/css";

export const Palette = (props) => {
  const [color, setColor] = useColor(props.colour);
  return <ColorPicker width={400} height={200} color={color} onChange={(e) => {props.newColour(e); setColor(e)}} hideInput={["rgb", "hsv"]} hideHEX hideAlpha dark />;
};

export default Palette;